import React, { useState, useEffect } from 'react';
import UserSidebar from './UserSidebar';
import UserHeader from './UserHeader';
import { useAuth } from '../../context/AuthContext';
import { useLocation } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import '../../assets/css/admin-custom.css';

interface UserDashboardLayoutProps {
    children: React.ReactNode;
}

const UserDashboardLayout: React.FC<UserDashboardLayoutProps> = ({ children }) => {
    const { user, loading } = useAuth();
    const [collapsed, setCollapsed] = useState(false);
    const [mobileShow, setMobileShow] = useState(false);
    const location = useLocation();
    const { theme } = useTheme();

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1024) {
                setMobileShow(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (theme === 'dark') {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    }, [theme]);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-slate-50 dark:bg-slate-950">
                <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-slate-50 dark:bg-slate-950 font-sans flex overflow-hidden">
            <UserSidebar
                collapsed={collapsed}
                mobileShow={mobileShow}
                setMobileShow={setMobileShow}
            />

            <div className="flex-1 flex flex-col min-w-0 relative h-screen">
                <UserHeader
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                    mobileShow={mobileShow}
                    setMobileShow={setMobileShow}
                />

                <main className="flex-1 overflow-y-auto overflow-x-hidden p-4 md:p-6 lg:px-4 lg:py-10 scroll-smooth">
                    <div className="max-w-[1600px] mx-auto animate-in fade-in slide-in-from-bottom-4 duration-700">
                        {children}
                    </div>
                </main>
            </div>

            {/* Mobile Overlay */}
            {mobileShow && (
                <div
                    className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[999] lg:hidden animate-in fade-in duration-300"
                    onClick={() => setMobileShow(false)}
                ></div>
            )}
        </div>
    );
};

export default UserDashboardLayout;
